module.exports = __webpack_public_path__ + "img/7.95d7b515.png";